// services/api/chatbot/chatbot.query.ts
import { gql } from "graphql-request";

/**
 * Read-only: the agent and KB folder are provisioned per org in the Blocks
 * console and their ids written to the org config there. The app never writes
 * this back, so the matching `updateorganizationconfig` mutation is gone.
 */
export const GET_ORG_CHATBOT_CONFIG = gql`
  query GetOrgChatbotConfig($orgId: String) {
    getorganizationconfigs(where: { OrganizationId: { eq: $orgId } }) {
      items {
        chatbotConfig {
          itemId
          kbFolderId
          widgetId
        }
      }
    }
  }
`;
